import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import SNACK_TYPES from "../const/snack_types";
import ErrorIcon from "@material-ui/icons/Error";

export default function CustomSnackbar(props) {
  const { snackMessage, onSnackbarClose, snackType } = props;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      open={!!snackMessage}
      autoHideDuration={3000}
      onClose={onSnackbarClose}
    >
      <SnackbarContent
        message={
          <span style={{ display: "flex", alignItems: "center" }}>
            <ErrorIcon
              style={{ fontSize: 20, opacity: 0.9, marginRight: "1rem" }}
            />
            {snackMessage}
          </span>
        }
        style={{
          backgroundColor: snackType
            ? SNACK_TYPES[snackType]
            : SNACK_TYPES.ERROR
        }}
      />
    </Snackbar>
  );
}
